import { useTheme } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import React from 'react';

export default function TitlePage({ title }) {
  const theme = useTheme();
  return (
    <Stack
      direction={{ xs: 'row', sm: 'row', md: 'row', lg: 'row' }}
      spacing={{ xs: 1, sm: 1, md: 3 }}
      mt={0}
      mb={2}
      p={1.5}
      sx={{
        background: theme.palette.primary.info,
        borderRadius: '20px',
      }}
    >
      <Typography variant="h5" fontWeight={600} color="primary.light">
        {title}
      </Typography>
    </Stack>
  );
}
